import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { env } from './lib/env'
import { router } from './lib/router'
import App from './App'
import './index.css'

if (env.sentryDsn) {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.firebaseProjectId.includes('staging')
      ? 'staging'
      : 'production',
    release: env.sentryRelease || undefined,
    enabled: !import.meta.env.DEV,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
